module.exports = __webpack_public_path__ + "static/media/product_640-6.f9249755.jpg";